import { nilaiSkala } from "@/lib/survei";

// Satu pernyataan survei + skala angka (radio asli disembunyikan -> tombol 44px, 2 baris x 5 di HP 390px).
// Radio asli dipakai supaya papan ketik (Tab, panah) & pembaca layar bekerja tanpa kode tambahan.
// Layar >= 1024px (lg): satu baris horizontal -- teks di kiri (lebar fleksibel), 10 tombol skala (36px) di kanan dgn
// label ujung di bawahnya. Di bawah 1024px tata letak TIDAK berubah (semua aturan khusus berawalan lg:/md:).
// `tb` (PR #109) = opsi TB {label, keterangan} bila butir ini boleh TB (selain itu null): radio tambahan di grup yg SAMA
// (memilih TB menghapus angka & sebaliknya). HP/tablet: tombol sendiri selebar penuh di bawah deretan angka (44px);
// laptop: di ujung kanan deretan, dipisah garis. Warna terpilih netral (abu), tidak menyiratkan nilai rendah/tinggi.
export default function SurveiSkala({ butir, urutan, skala, nilai, onPilih, disorot, tb = null }) {
    const id = `butir-${butir.no}`;
    return (
        <fieldset
            id={id}
            data-testid={id}
            className={`scroll-mt-24 rounded-xl border p-3 md:scroll-mt-32 lg:grid lg:items-center lg:gap-x-8 lg:px-4 lg:py-3 ${tb ? "lg:grid-cols-[minmax(0,1fr)_auto]" : "lg:grid-cols-[minmax(0,1fr)_27rem]"} ${disorot ? "border-rose-500 ring-2 ring-rose-500/40" : "border-border"}`}
        >
            <legend className="sr-only">Pernyataan {urutan}</legend>
            <p className="text-sm leading-relaxed text-foreground">
                <span className="font-bold">{urutan}.</span> {butir.teks}
            </p>
            <div className={tb ? "lg:flex lg:items-start lg:gap-3" : undefined}>
            <div className={tb ? "lg:w-[27rem]" : undefined}>
            <div className="mt-3 grid grid-cols-5 gap-2 sm:grid-cols-10 sm:gap-1.5 lg:mt-0">
                {nilaiSkala(skala).map((v) => (
                    <label key={v} className="block">
                        <input
                            type="radio"
                            name={id}
                            value={v}
                            checked={nilai === v}
                            onChange={() => onPilih(butir.no, v)}
                            className="peer sr-only"
                            aria-label={`${v}${v === skala.min ? ` (${skala.label_min})` : v === skala.maks ? ` (${skala.label_maks})` : ""}`}
                        />
                        <span className="flex h-11 cursor-pointer select-none items-center justify-center rounded-lg border border-border bg-card text-sm font-semibold text-foreground transition-colors hover:bg-muted peer-checked:border-[#00B9AD] peer-checked:bg-[#00B9AD] peer-checked:text-[#0F2E30] lg:h-9 peer-focus-visible:ring-2 peer-focus-visible:ring-foreground lg:peer-focus-visible:ring-offset-2 lg:peer-focus-visible:ring-offset-card">
                            {v}
                        </span>
                    </label>
                ))}
            </div>
            <div className="mt-1.5 hidden justify-between text-[11px] text-muted-foreground lg:flex" aria-hidden="true">
                <span>1 · {skala.label_min}</span>
                <span>{skala.label_maks} · {skala.maks}</span>
            </div>
            </div>
            {tb && (
                <label className="mt-2 block lg:mt-0 lg:border-l lg:border-border lg:pl-3" data-testid={`${id}-tb`}>
                    <input
                        type="radio"
                        name={id}
                        value="TB"
                        checked={nilai === "TB"}
                        onChange={() => onPilih(butir.no, "TB")}
                        className="peer sr-only"
                        aria-label={tb.keterangan}
                    />
                    <span title={tb.keterangan} className="flex h-11 cursor-pointer select-none items-center justify-center rounded-lg border border-dashed border-border bg-card px-3 text-sm font-semibold text-muted-foreground transition-colors hover:bg-muted peer-checked:border-solid peer-checked:border-slate-600 peer-checked:bg-slate-600 peer-checked:text-white lg:h-9 lg:min-w-[3.5rem] peer-focus-visible:ring-2 peer-focus-visible:ring-foreground lg:peer-focus-visible:ring-offset-2 lg:peer-focus-visible:ring-offset-card">
                        {tb.label}
                    </span>
                </label>
            )}
            </div>
            {disorot && <p className="mt-2 text-xs font-semibold text-rose-600 lg:col-span-2">Pernyataan ini belum dijawab.</p>}
        </fieldset>
    );
}
